module.exports = __webpack_public_path__ + "static/media/discount-code.47e227be.png";